module.exports = __webpack_public_path__ + "img/occurence-hausse.eb700dcf.svg";